"use strict";
exports.__esModule = true;
exports.MediaType = void 0;
var MediaType;
(function (MediaType) {
    MediaType["Audio"] = "audio";
    MediaType["Communication"] = "communication";
    MediaType["Infographic"] = "infographic";
    MediaType["Photo"] = "photo";
    MediaType["Publication"] = "publication";
    MediaType["Release"] = "release";
    MediaType["Video"] = "video";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
//# sourceMappingURL=media-type.js.map